export const CREATE_OBJECT_TIME_INPUT_MAX_LENGTH = 5

export const formatCreateObjectTimeInput = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 4)

  if (/^[3-9]$/.test(digits)) {
    return `0${digits}`
  }

  if (digits.length <= 2) {
    return digits
  }

  const minutes = Math.min(Number(digits.slice(2)), 59)
    .toString()
    .padStart(digits.length === 4 ? 2 : 1, '0')

  return `${digits.slice(0, 2)}:${minutes}`
}
